import "./index.scss";
import i18n from "../../locales/i18n";
import { Box } from "fds";

const TermsPage = ({ height = "100%" }: { height?: string | number }) => {
  return (
    <Box classes="wsTermsPage" height={height}>
      {i18n.language.includes("ko") ? (
        <iframe
          src="/cloudportal_terms.html"
          width="100%"
          style={{ border: "none" }}
          title="terms"
          height={height || "640px"}
        />
      ) : (
        <ul>
          <li>
            <h3 className="title">Chapter 1 General Provisions</h3>
            <ul>
              <li>
                <h4 className="subTitle">Article 1 (Purpose)</h4>
                <p className="contents">
                  These provisions aim to prescribe Fasoo Co., Ltd (hereafter
                  "the Company") and its users' rights, obligations, and
                  responsibilities in using wired and wireless internet service,
                  Wrapsody eCo service (hereafter "the Service").
                </p>
              </li>
              <li>
                <h4 className="subTitle">Article 2 (Definition)</h4>
                <p className="contents">
                  Terms used in this Terms of Service have the following
                  meanings:
                </p>
                <ul>
                  <li>
                    <p className="contents">
                      "Service": All goods and services provided by the Company
                      to members through devices (including PCs, mobile devices
                      such as smart phones and other various wired and wireless
                      devices) or programs.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      "Member": A customer consents to these Terms of Service
                      and uses the Service provided by the Company
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      "Site": Service including web-based wired and wireless
                      homepage (https://*.wrapsodyeco.com).
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      Application: A program installed on supported portable
                      devices of the service.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      ID: An e-mail address entered by a member to distinguish
                      an identity or using services.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      Password: A combination of 8 or more letters, numbers, or
                      special characters which a member provides and registers
                      in order to verify a member's identity and to protect
                      confidentiality.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      Posts: All digital content including document members
                      register on the Wrapsody eCo site.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      Operator: A person designated by the Company for overall
                      management and smooth operation of the service.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      Paid Service: An optional service that allows users to
                      select the service provided by the Company according to
                      their needs.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <h4 className="subTitle">
                  Article 3 (Effectiveness and Amendment of Provisions)
                </h4>
                <p className="contents">
                  This Terms of Service is effective for all members who want to
                  use the service.
                </p>
                <p className="contents">
                  These Terms of Service can be viewed by members when signing
                  up for the service, and the Company publishes these Terms of
                  Service on the website and application to allow Users to view
                  the Terms of Service whenever they want.
                </p>
                <p className="contents">
                  The Company may revise these Terms of Service to the extent
                  that they do not violate related laws such as the "Act on the
                  Stability of Terms and Conditions", "Act on Consumer
                  Protection such as E-Commerce", "Act on Promotion of
                  Information and Communications Network Utilization and
                  Information Protection Rules", "Online Digital Content
                  Industry Development Act", and the "Consumer Standards Act".
                </p>
                <p className="contents">
                  The company may change these Terms of Service if deemed
                  necessary. In the event of amending Terms of Service, the
                  Company shall notify users of the causes of amendment and
                  applied from fifteen (15) days prior to date such amendments
                  will be in effect to the day before applied date.
                </p>
                <p className="contents">
                  In amending these Terms of Service, the Company will notify or
                  announce the revised Terms of Service in accordance with
                  paragraph 3 and confirm whether a member consents to the
                  application of the amended Terms of Service after their
                  publication; provided, however, a User may be deemed to have
                  consented to the amended Terms of Service if the User fails to
                  express consent or disagreement until their effective date and
                  the Company has published together with the amended Terms of
                  Service that such failure shall be deemed as the User's
                  consent
                </p>
                <p className="contents">
                  If a User disagrees to the application of the revised/amended
                  Terms of Service, the User may withdraw from the Service and
                  terminate the contract.
                </p>
                <p className="contents">
                  The members have a duty to monitor changes in Terms of Service
                  carefully, and the Company is not responsible for the member's
                  damage caused by ignorance of the changed Terms of Service.
                </p>
              </li>
              <li>
                <h4 className="subTitle">
                  Article 4 (Other terms and conditions)
                </h4>
                <p className="contents">
                  Any matters that are not prescribed in this Terms of Service
                  shall be subject to the relevant laws and regulations.
                </p>
                <p className="contents">
                  The Company, if deemed necessary, can define the Terms of
                  Service for the individual services, and operation policies.
                  In case of conflict between these Terms of Service and the
                  Terms of Service for particular services or operation
                  policies, the rules set forth by the Company shall take
                  precedence.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <h3 className="title">Chapter 2 Service Use Contract</h3>
            <ul>
              <li>
                <h4 className="subTitle">
                  Article 5 (Establishment of Contract of Use)
                </h4>
                <p className="contents">
                  The contact of use shall come into effect when the Company
                  accepts a membership request after the user completes the
                  application form set by the Company and check "I agree" to
                  this Terms of Service and the "Privacy Policy".
                </p>
                <p className="contents">
                  When the application for sign-up has been completed, the
                  Company must confirm if the requirements are met and approve
                  it without delay.
                </p>
                <p className="contents">
                  When the applicant for membership sign-up selects "I agree" to
                  all items and fills out the application form, it is regarded
                  that he or she has read these Terms of Service and Privacy
                  Policy and agrees to follow the various policies that the
                  company operates to provide the Service and frequent notices
                  from the company.
                </p>
              </li>
              <li>
                <h4 className="subTitle">
                  Article 6 (Suspension and Refusal of User Contract)
                </h4>
                <p className="contents">
                  The Company may suspend acceptance or terminate the use
                  contract afterwards for the following reasons:
                </p>
                <ul>
                  <li>
                    <p className="contents">
                      1) In cases where an applicant has written false
                      information in the application form
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      2) In cases where an applicant has used somebody else´s
                      e-mail for verification.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      3) In cases where an applicant for membership has lost the
                      qualification for membership in the past according to the
                      Terms of Service. However, this does not apply if he/she
                      has obtained the permission of reapplication for
                      membership from the Company.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      4) In cases where it is impossible to approve due to a
                      reason attributable to the user or the user has applied
                      for the membership in violation of other regulated matters
                    </p>
                  </li>
                </ul>
                <p className="contents">
                  The Company may request the verification of the user's real
                  name through a specialized agency and user authentication for
                  the application according to Paragraph 1.
                </p>
                <p className="contents">
                  The Company may defer approval of registration for the
                  following reasons:
                </p>
                <ul>
                  <li>
                    <p className="contents">
                      1) In cases when there are no available service-related
                      facilities
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      2) In case when a technical issue exists to provide the
                      Service
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      3) In case where it is deemed necessary financially and
                      technically by the company
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      4) In case when it is difficult to approve for other
                      reasons
                    </p>
                  </li>
                </ul>
                <p className="contents">
                  If approval for the application for membership according is
                  not given or deferred according to Paragraphs 1 and 3, the
                  Company shall inform the applicant for membership of the
                  refusal.
                </p>
                <p className="contents">
                  The use agreement is concluded when the Company marks the
                  subscription complete on the application procedure.
                </p>
              </li>
              <li>
                <h4 className="subTitle">
                  Article 7 (Obligation to Manage Members)
                </h4>
                <p className="contents">
                  The member shall be responsible for any damages caused by the
                  member's intention or negligence in managing his/ her account
                  ID and password to use the Service. However, if the Company's
                  intention or negligence caused any disadvantages, the Company
                  take the responsibilities.
                </p>
                <p className="contents">
                  If the user recognizes that the ID and password are used by a
                  third party, the user should immediately take measures
                  including changing the password, and notify the Company and
                  follow the instructions of the company
                </p>
              </li>
              <li>
                <h4 className="subTitle">
                  Article 8 (Obligation to Protect Personal Information)
                </h4>
                <p className="contents">
                  The Company does not collect any personal information except
                  for the ID (e-mail) and password that are basically required
                  to provide the Service.
                </p>
                <p className="contents">
                  The Company can use the ID entered by the member when signing
                  up except for the password to provide services and to indicate
                  the source of data.
                </p>
                <p className="contents">
                  The Company tries to protect the password entered by the
                  member when registering as a member through high-level
                  encryption so that the Company and third parties cannot
                  detect.
                </p>
                <p className="contents">
                  The Company's "Privacy Policy" is not applied to other
                  websites (that are not operated by the Company) linked to the
                  Service.
                </p>
                <p className="contents">
                  The Company can entrust some or all of these tasks to a
                  company selected by the Company if necessary. It will notify
                  in the "Privacy Policy" when entrusting tasks related to
                  handling and managing member information or service operation
                  information.
                </p>
                <p className="contents">
                  The Company is not responsible for the information disclosure
                  due to a member's fault can provide members' information in
                  the following cases.
                </p>
                <ul>
                  <li>
                    <p className="contents">
                      1) When an investigative agency or other governmental
                      agency requests to provide information as a member
                      violates applicable laws while using the Service.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      2) When it is necessary for information protection
                      activities such as confirmation of a violation of the
                      legislation by a member and fraud act, including violation
                      of these Terms of Service.
                    </p>
                  </li>
                  <li>
                    <p className="contents">3) When required by other laws</p>
                  </li>
                </ul>
                <p className="contents">
                  The Company tries to protect members' personal information in
                  accordance with related laws and regulations, such as the
                  "Information and Communication Network Act". Regarding the
                  protection and use of personal information, the relevant laws
                  and the Company's personal information processing policy is
                  applied. However, However, the Company's privacy policy does
                  not apply to linked sites other than the Company's official
                  website.
                </p>
                <p className="contents">
                  The Company may request the minimum information (name,
                  address, phone number) required for payment of products, and
                  does not store financial information related to the payment.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <h3 className="title">Chapter 3 Use of Service</h3>
            <ul>
              <li>
                <h4 className="subTitle">Article 9 (Provision of Service)</h4>
                <p className="contents">
                  The Company provides the following services to members:
                </p>
                <ul>
                  <li>
                    <p className="contents">
                      1) Wrapsody eCo (Editing and sharing service for encrypted
                      documents)
                    </p>
                  </li>
                </ul>
                <p className="contents">
                  Members can use the service from the time the company approves
                  the application of use. The company will start to provide the
                  service from the time of approval. However, paid service can
                  be available immediately after the company confirms the
                  payment of fees
                </p>
              </li>
              <li>
                <h4 className="subTitle">Article 10 (Use of the Service)</h4>
                <p className="contents">
                  The services are available 24 hours a day, seven days a week,
                  365 days a year. The Company may separately set the service
                  hours for all or part of the services provided.
                </p>
                <p className="contents">
                  The company can conduct regular and irregular inspections if
                  necessary for the provision of services, and the inspection
                  time is as announced on the service provision screen.
                </p>
              </li>
              <li>
                <h4 className="subTitle">
                  Article 11 (Changes and Suspensions of the Service)
                </h4>
                <p className="contents">
                  The company may notify the member of the contents and the date
                  of provision of the Service to be changed in the manner
                  specified in Article 20 and can provide the modified service.
                </p>
                <p className="contents">
                  The Company may limit or suspend the use of the Service in the
                  following cases.
                </p>
                <ul>
                  <li>
                    <p className="contents">
                      1) When a member interferes with the Company's sales
                      activities
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      2) When regular service is not available due to heavy
                      traffic
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      3) When a telecommunication service provider prescribed by
                      the Telecommunications Business Act stops
                      telecommunication services
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      4) When regular service is not possible due to
                      infrastructure failure or heavy traffic.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      5) When the Company deems that it is inappropriate to
                      continue providing services due to other serious reasons.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      6) When there are force majeure reasons such as natural
                      disasters or national emergencies.
                    </p>
                  </li>
                </ul>
                <p className="contents">
                  The Company shall notify the member as prescribed in Article
                  21 when suspending the Service according to Paragraph 2.
                  However, this is not the case if advance notice is not
                  possible due to service interruption (disruption of the disk
                  without operator's intention or negligence, system down, etc.)
                  due to reasons beyond the Company's control.
                </p>
                <p className="contents">
                  The Company is not responsible for any problems caused by the
                  change or suspension of the Service.
                </p>
              </li>
              <li>
                <h4 className="subTitle">
                  Article 12 (Provision of information and Insertion of
                  Advertisement)
                </h4>
                <p className="contents">
                  Members might agree to be exposed to the advertisements while
                  using the Service.{" "}
                </p>
                <p className="contents">
                  The Company can provide advertisements to service users.{" "}
                </p>
                <p className="contents">
                  It is entirely a matter between the member and the advertiser
                  when a member communicates or trades by using advertising on
                  the service or participating in the advertiser's promotional
                  activities through the Service.
                </p>
                <p className="contents">
                  In the event of a dispute or other problem between a member
                  and an advertiser, the member and the advertiser must settle
                  it themselves, and the Company does not take any
                  responsibility in this regard.
                </p>
              </li>
              <li>
                <h4 className="subTitle">Article 13 (Copyright of Post)</h4>
                <p className="contents">
                  The Company may not use the post for other purposes without
                  the consent of the posted member.
                </p>
                <p className="contents">
                  The Company shall not be civilly and criminally liable even if
                  the posts posted by the members in the Service infringe on the
                  copyrights and other rights of others. If a member receives an
                  objection, such as a claim for damages because a member has
                  violated the copyright or other rights of the other person,
                  the members must make efforts to indemnify the Company, and
                  the member must bear all damages caused to the Company.
                </p>
                <p className="contents">
                  The Company may delete the posts posted by members if the
                  member terminates the use contract and withdraws from the
                  site, or if the agreement is terminated for a legitimate
                  reason.
                </p>
                <p className="contents">
                  The copyright of the work created by the Company belongs to
                  the Company.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <h3 className="title">
              Chapter 4 Obligation of Contracting Parties
            </h3>
            <ul>
              <li>
                <h4 className="subTitle">
                  Article 14 (Obligation of the Company)
                </h4>
                <p className="contents">
                  The Company must sincerely implement measures such as
                  maintenance, inspection, or restoration to ensure that
                  facilities related to service provision and security are
                  suitable to provide continuous and stable service.
                </p>
                <p className="contents">
                  The Company does not conduct any activates that are prohibited
                  by the relevant laws and these Terms and Services or contrary
                  to the customs, and does its best to continuously and reliably
                  provide services.
                </p>
                <p className="contents">
                  The company must have a security system to protect personal
                  information so that users can safely use the service, announce
                  and comply with the "Privacy Policy", and try to protect
                  member's personal information without leaking or distributing
                  to third parties without their consent.
                </p>
                <p className="contents">
                  The company must handle the opinions or complaints raised by
                  members regarding the use of the service when it is justified.
                  When an opinions or a complaint is raised by a member,
                  processing schedule, process, and results should be notified
                  to the member via bulletin board or e-mail.
                </p>
                <p className="contents">
                  If the member suffers damages due to the services provided by
                  the company due to the services provided by the company, the
                  company bears the responsibility only if such damage is caused
                  by the company's intention or negligence, and the scope of the
                  responsibility is limited to ordinary damages.
                </p>
                <p className="contents">
                  The company does not send commercial e-mails for commercial
                  purposes without the member's consent to receive them.
                </p>
                <p className="contents">
                  The company complies with laws and regulations related to the
                  operation and maintenance of services such as the "Act on
                  Promotion of Information and Communications Network
                  Utilization and Information Protection", "Communication Secret
                  Protection Act", and "Telecommunications Business Act".
                </p>
              </li>
              <li>
                <h4 className="subTitle">
                  Article 15 (Obligation of the Members)
                </h4>
                <p className="contents">
                  The members must perform none of the following activities.
                </p>
                <ul>
                  <li>
                    <p className="contents">
                      1) Inappropriately or unjustifiably use the service by
                      stealing other member's email and password, or steal
                      information
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      2) Act of using the company's paid service by using
                      payment information of others without the permission of
                      others, such as account numbers and credit card numbers of
                      others
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      3) Act of Changing the information posted by the company
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      4) Sending or posting information (computer programs,
                      etc.) other than the information specified by the company
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      5) Violate other rights of the Company or a third party
                      including copyright
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      6) Defame or injure reputation of the company or a third
                      party, or interrupt business
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      7) The act of using the service for profit without the
                      consent of the company
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      8) Posting a post or sending an e-mail by impersonating or
                      impersonating a manager of a company employee or service,
                      or stealing another person's name
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      9) Act of posting or distributing any material that
                      contains software virus, other computer code, file or
                      program designed to disrupt or destroy normal operation of
                      the equipment related to the service.
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      10) Act of re-engineering, reverse engineering,
                      decompiling, and disassembling software provided by the
                      company
                    </p>
                  </li>
                  <li>
                    <p className="contents">
                      11) Collect, store and/or disclose other member's personal
                      information
                    </p>
                  </li>
                  <li>
                    <p className="contents">12) Other Illegal and unfair act</p>
                  </li>
                </ul>
                <p className="contents">
                  Members must comply with relevant laws, provisions of these
                  Terms and Services, notice of use and notices on the service,
                  and notices of the company, and shall not engage in any other
                  act that interferes with the company's business.
                </p>
                <p className="contents">
                  Members shall neither transfer nor grant their rights to use
                  and legal status hereby, nor impignorate the foregoing rights
                  and status
                </p>
                <p className="contents">
                  Members must thoroughly manage the password specified in
                  Article 7 (Obligation of the Members). he member is
                  responsible for all the consequences caused by negligence,
                  misuse, etc., and the company does not take any responsibility
                  for it.
                </p>
                <p className="contents">
                  Under the Civil Law, if a member who is a minor uses the paid
                  service, the member who is a minor must obtain the consent of
                  the legal representative before payment.
                </p>
              </li>
              <li>
                <h4 className="subTitle">
                  Article 16 (Notification and Announcement to the Members)
                </h4>
                <p className="contents">
                  If the company notifies the member, it can be done through the
                  "homepage" notice that does not have a separate regulation in
                  this Terms of Service.
                </p>
                <p className="contents">
                  In the case of notice to multiple unspecified members, the
                  company can replace individual notices by posting it on
                  "homepage".
                </p>
              </li>
              <li>
                <h4 className="subTitle">
                  Article 17 (Termination of the Service)
                </h4>
                <p className="contents">
                  When a member wants to terminate the contract of use, the
                  member himself/herself can apply for termination through the
                  menu of cancellation request (withdrawal request) on the site
                  or information on how to cancel.
                </p>
                <p className="contents">
                  When the company receives an application for cancellation of
                  registration, the company must terminate the use of the
                  member's service before the point the member wants.
                </p>
                <p className="contents">
                  When a member terminates the contract, all data of the member
                  is destroyed immediately upon termination, except when the
                  company holds the member information in accordance with
                  applicable laws and personal information processing policies.
                </p>
              </li>
              <li>
                <h4 className="subTitle">
                  Article 18 (Use Restrictions of the Service)
                </h4>
                <p className="contents">
                  In the event that a member violates these Terms of Service or
                  Terms of Service of individual services, the Company may limit
                  the use of the service at the stages of warning, temporary
                  suspension, and permanent suspension, or terminate the use
                  contract.
                </p>
                <p className="contents">
                  The member can make an objection to the use of the service
                  pursuant to Paragraph 1 or use restrictions related to the use
                  of the service in accordance with the procedures set by the
                  Company, and the company immediately resumes using the service
                  when it is deemed that the member's objection is justified.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <h3 className="title">Chapter 5 Others</h3>
            <ul>
              <li>
                <h4 className="subTitle">
                  Article 19 (Indemnification for Damage)
                </h4>
                <p className="contents">
                  If a member causes damages to the company due to violation of
                  the provisions of these Terms of Services, the member who
                  violates these Terms of Services shall compensate all damages
                  to the company.
                </p>
                <p className="contents">
                  In the event that the Company receives various complaints
                  including claims for damages or lawsuits from third parties
                  other than the member due to illegal acts or violations of
                  these terms and conditions in the process of using the
                  service, the member is responsible for the Company at his/her
                  own responsibility and expense. The Company must indemnify and
                  if the company fails to indemnify, the member must compensate
                  for any damages caused to the Company.
                </p>
              </li>
              <li>
                <h4 className="subTitle">Article 20 (Disclaimer)</h4>
                <p className="contents">
                  If the Company is unable to provide the service due to a
                  natural disaster or equivalent force majeure, the Company is
                  exempted from liability for Service provision.
                </p>
                <p className="contents">
                  The company is not responsible for the failure to use the
                  service due to a member's fault.
                </p>
                <p className="contents">
                  The Company shall not be held responsible for not meeting
                  customers' expectations for profit through the use of this
                  Service, or loss or damage caused by the Service. The Company
                  is not responsible for the content of posts posted in the site
                  by members regarding accuracy.
                </p>
                <p className="contents">
                  The company is not obliged to intervene in disputes between
                  members or between a member and a third party that arose from
                  the service as a medium, and is not responsible for
                  reimbursing damages.
                </p>
              </li>
              <li>
                <h4 className="subTitle">
                  Article 21 (Dispute Settlement and Competent Jurisdiction)
                </h4>
                <p className="contents">
                  When a lawsuit is filed against a dispute between the Company
                  and a member, Korean law shall apply.
                </p>
                <p className="contents">
                  If the Company file a lawsuit in relation to the use of the
                  Service, the court under the Civil Procedure Act shall be the
                  competent court.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <h4 className="subTitle">Additional Terms</h4>
            <p className="contents">
              [Enforcement Date] These Terms of Service takes effect on July 1,
              2020.
            </p>
            <p className="contents">- Notification Date: July 1, 2020</p>
            <p className="contents">- Enforcement Date: July 1, 2020</p>
          </li>
        </ul>
      )}
    </Box>
  );
};

export default TermsPage;
